module.exports = __webpack_public_path__ + "img/default_sample.3d6b943e.png";